var map = {
	"./social-500px.svg": 136,
	"./social-dribbble.svg": 137,
	"./social-facebook.svg": 138,
	"./social-github.svg": 139,
	"./social-google.svg": 140,
	"./social-instagram.svg": 141,
	"./social-odnoklassniki.svg": 142,
	"./social-reddit.svg": 143,
	"./social-stackoverflow.svg": 144,
	"./social-steam.svg": 145,
	"./social-twitch.svg": 146,
	"./social-twitter.svg": 147,
	"./social-vkontakte.svg": 148,
	"./social-windows.svg": 149,
	"./social-yahoo.svg": 150
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 135
// module chunks = 0